(function (window) {
  'use strict';

  var mounted = [];

  function find(stage) {
    for (var i = 0; i < mounted.length; i += 1) {
      if (mounted[i].stage === stage) return mounted[i];
    }
    return null;
  }

  function srcFor(images, colorId) {
    return (images && (images[colorId] || images.black)) || '';
  }

  function CableCard(stage, opts) {
    this.stage = stage;
    this.image = document.createElement('img');
    this.image.className = 'umbrella-configurator__oryzo-image';
    this.image.alt = '';
    this.image.setAttribute('aria-hidden', 'true');
    this.image.draggable = false;
    stage.insertBefore(this.image, stage.firstChild);

    this.images = opts.images || opts.videos || {};
    this.colorId = opts.colorId || 'black';
    this.applySrc();
  }

  CableCard.prototype.applySrc = function () {
    var next = srcFor(this.images, this.colorId);
    if (!next) return;
    var abs = new URL(next, window.location.href).href;
    if (this.image.src === abs) return;
    this.image.src = next;
  };

  CableCard.prototype.set = function (opts) {
    if (opts.images) this.images = opts.images;
    else if (opts.videos) this.images = opts.videos;
    if (opts.colorId) this.colorId = opts.colorId;
    this.applySrc();
  };

  CableCard.prototype.setPlaying = function () {};

  CableCard.prototype.destroy = function () {
    this.image.removeAttribute('src');
    if (this.image.parentNode) this.image.parentNode.removeChild(this.image);
  };

  window.LeavesCableCard = {
    mount: function (stage, opts) {
      var existing = find(stage);
      if (existing) {
        existing.set(opts || {});
        return existing;
      }
      var card = new CableCard(stage, opts || {});
      mounted.push(card);
      return card;
    },
    update: function (stage, opts) {
      var card = find(stage);
      if (card) card.set(opts || {});
    },
    setPlaying: function (stage, playing) {
      var card = find(stage);
      if (card) card.setPlaying(playing);
    },
    setStepActive: function (active) {
      mounted.forEach(function (card) {
        card.setPlaying(active);
      });
    },
    destroy: function (stage) {
      var card = find(stage);
      if (!card) return;
      card.destroy();
      mounted = mounted.filter(function (item) {
        return item !== card;
      });
    },
  };
})(window);
